import { render, staticRenderFns } from "./DocumentUploadModal.vue?vue&type=template&id=5f41280a&scoped=true&lang=pug&"
import script from "./DocumentUploadModal.vue?vue&type=script&lang=js&"
export * from "./DocumentUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUploadModal.vue?vue&type=style&index=0&id=5f41280a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f41280a",
  null
  
)

export default component.exports